import React from 'react';
import { useTranslation } from 'react-i18next';
import './Marquee.css';

const Marquee = () => {
  const { t } = useTranslation();
  
  return (
    <section className="marquee-section">
      <div className="marquee-container">
        <div className="marquee-content">
          <div className="marquee-track">
            <div className="marquee-item">{t('marqueeText')}</div>
            <div className="marquee-item">{t('marqueeText')}</div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Marquee;
